

import React, { Component } from "react";
import { withRouter } from "./withRouter";
import  {  Popup } from "react-map-gl";
import { makeHeatScale } from "./utils/colorUtils";
import { buildLabelsAndColors } from "./constants/partyConfig";
import { ISSUE_INFO } from "./constants/issueConfig";

class TooltipInternalHeatMap extends Component {
 
  
             
buildTooltip(hoverInfo, styledGeo) {
  const { geoLevel } = this.props;
  if (!hoverInfo || !styledGeo) return null;

  const { area_name, _allValuesSorted } = hoverInfo.props;

  // Map level label
  let area_type_label;
  switch (geoLevel) {
    case "constituency":
      area_type_label = "Electorate";
      break;
    default:
      area_type_label = geoLevel;
      break;
  }

  // Parse and select top 3
  let topIssues = [];
try {
  const parsed = JSON.parse(_allValuesSorted);
  topIssues = parsed.filter(issue => issue.key === this.props.chosenParty);
} catch (e) {
  console.warn("Could not parse _allValuesSorted:", e);
}

  // Colour lookup
  const { colors } = buildLabelsAndColors(ISSUE_INFO);

  // Tooltip container
  return (
    <div
      style={{
        fontSize: "12px",
        background: "rgba(255,255,255,0.95)",
        borderRadius: "6px",
        padding: "6px 8px",
        boxShadow: "0 0 6px rgba(0,0,0,0.15)",
        maxWidth: "180px",
      }}
    >
      <strong>{area_name}</strong> {area_type_label}
      <div style={{ marginTop: 6 }}>
        {topIssues.length > 0 ? (
          topIssues.map((issue, i) => {
            const colour = colors[issue.key] || "#888";
            const value = Number(issue.area_id) || 0;
            return (
              <div key={i} style={{ marginBottom: 4 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: 500,
                    marginBottom: 2,
                  }}
                >
                  <span>{issue.area_name}</span>
                  <span>{value.toFixed(1)}%</span>
                </div>
                <div
                  style={{
                    height: "6px",
                    background: "#e0e0e0",
                    borderRadius: "3px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${value}%`,
                      background: colour,
                      height: "100%",
                      borderRadius: "3px",
                    }}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <span>No issue data</span>
        )}
      </div>
    </div>
  );
}








 

  render() {    
    const {  styledGeo,  hoverInfo} = this.props;

   
  return (
    <>
      {styledGeo && hoverInfo && hoverInfo?.props?.topValue>0 &&(
        <Popup
          longitude={hoverInfo.lon}
          latitude={hoverInfo.lat}
          closeButton={false}
          closeOnClick={false}
          offset={12}
          dynamicPosition={true}
          maxWidth="500px"
  className="no-popup-frame"  // 👈 add this
        >
          {this.buildTooltip(hoverInfo, styledGeo, this.props.tooltip_pastcomp)}
        </Popup>
      )}
    </>
  );
}
}
    
    export default withRouter(TooltipInternalHeatMap);
    